module.exports = __webpack_public_path__ + "static/media/rings.91762b2a.svg";